module.exports = __webpack_public_path__ + "img/gns-software-logo.eb82c8cd.svg";